import React from 'react';
import { Typography } from './Typography';
import { HeartPulseIcon, BatteryIcon, SmartphoneIcon, HandIcon } from 'lucide-react';
import { t } from '../src/locales';
export const FeatureSection = () => {
  const features = t('features.items');
  const featureIcons = [<HandIcon size={32} className="text-[#004FFF] mr-4 mt-1 flex-shrink-0" data-id="element-33" />, <HeartPulseIcon size={32} className="text-[#004FFF] mr-4 mt-1 flex-shrink-0" data-id="element-34" />, <BatteryIcon size={32} className="text-[#004FFF] mr-4 mt-1 flex-shrink-0" data-id="element-35" />, <SmartphoneIcon size={32} className="text-[#004FFF] mr-4 mt-1 flex-shrink-0" data-id="element-36" />];
  return <section id="features" className="w-full bg-[#192636] py-20 px-6 md:px-12" data-id="element-37">
      <div className="max-w-6xl mx-auto" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <h2 className="text-[50px] leading-[56px] text-white font-[200] mb-4" data-id="element-40">
            {t('features.title')}
          </h2>
          <Typography variant="medium" className="text-white max-w-2xl mx-auto" data-id="element-41">
            {t('features.description')}
          </Typography>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-42">
          <div data-id="element-43">
            <img src="https://sleep.moonbird.life/lovable-uploads/b46006a4-aa73-4dee-b83f-9c72abe62c16.png" alt="moonbird breathing device" className="rounded-xl shadow-lg w-full h-auto" data-id="element-44" />
          </div>
          <div className="space-y-8" data-id="element-45">
            {features.map((feature, index) => <div key={index} className="flex items-start" data-id="element-46">
                {featureIcons[index]}
                <div data-id="element-47">
                  <Typography variant="large" as="h3" className="text-white mb-2 font-[200]" data-id="element-48">
                    {feature.title}
                  </Typography>
                  <Typography variant="small" className="text-white opacity-80" data-id="element-49">
                    {feature.description}
                  </Typography>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};